import script from "./DayGlyph.vue?vue&type=script&setup=true&lang=js"
export * from "./DayGlyph.vue?vue&type=script&setup=true&lang=js"

import "./DayGlyph.vue?vue&type=style&index=0&id=387d69d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387d69d5"]])

export default __exports__